import type { FC } from "react";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";

interface StartButtonProps {
  disabled: boolean;
  isLoading: boolean;
  onClick: () => void;
}

// TODO: will rename to ConfirmGroupButton in a follow-up PR
export const StartButton: FC<StartButtonProps> = ({ disabled, isLoading, onClick }) => {
  return (
    <LegacyButton
      color="green"
      disabled={disabled}
      isLoading={isLoading}
      kind="primary"
      size="xs"
      title={
        disabled
          ? t("student_self_select_card.tooltip.group_full")
          : t("student_self_select_card.tooltip.start_activity")
      }
      onClick={onClick}
    >
      {t("common.confirm_group")}
    </LegacyButton>
  );
};
